import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import {
  Message,
  Headline,
  Text,
  PlanLoaderImage,
  PlanLoaderContent,
} from './PlanLoaderMessage.styles';

export const PlanLoaderMessage = ({
  bgColor,
  orientation = 'column',
  headline,
  text,
  image,
}) => (
  <Message bgColor={bgColor} orientation={orientation}>
    {image && (
      <PlanLoaderImage orientation={orientation}>
        <ResponsiveImage
          src={image.src}
          alt={image.alt}
          width={image.width}
          height={image.height}
        />
      </PlanLoaderImage>
    )}
    <PlanLoaderContent>
      <Headline>{headline}</Headline>
      <Text>{text}</Text>
    </PlanLoaderContent>
  </Message>
);
PlanLoaderMessage.displayName = 'PlanLoaderMessage';
PlanLoaderMessage.propTypes = {
  orientation: PropTypes.oneOf(['row', 'column']),
  bgColor: PropTypes.string,
  headline: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }),
};
